import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const FAQS = [{
  q: 'What exactly is The Knee Geometry Method?',
  a: "It's a digital guide with a complete 15-day plan that rebuilds knee angles, stability, and walking confidence—at home, low impact."
}, {
  q: 'How do I receive the content?',
  a: 'Instantly! You get immediate access via email after purchase.'
}, {
  q: 'Is this safe for my knee?',
  a: 'Yes. The program uses chair, wall, and resistance band exercises only. No impact, no deep knee bends. Plus the Pain Traffic Light system lets you adjust daily.'
}, {
  q: 'What if I have a flare-up?',
  a: "The included 24-48 hour Flare-Up Protocol tells you exactly what to do so one bad day doesn't erase your progress."
}, {
  q: 'Who is this NOT for?',
  a: 'This is not medical treatment. If you have severe swelling, heat/redness, locking, sudden inability to bear weight, recent injury, or sharp escalating pain—see a doctor first.'
}, {
  q: 'What equipment do I need?',
  a: "A chair, a wall, and a resistance band. That's it. No gym required."
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="my-12" data-id="element-136">
      <h2 className="text-[24px] font-bold text-[#1a1a1a] mb-6 font-serif" data-id="element-137">
        Common Questions
      </h2>

      <div className="border-t border-[#E5E5E0]" data-id="element-138">
        {FAQS.map((faq, index) => <div key={index} className="border-b border-[#E5E5E0]" data-id="element-139">
            <button className="w-full py-4 flex items-center justify-between text-left focus:outline-none group" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-140">
              <span className="text-[16px] font-bold text-[#1a1a1a] font-serif group-hover:text-[#8B2500] transition-colors" data-id="element-141">
                {faq.q}
              </span>
              {openIndex === index ? <ChevronUp size={16} className="text-[#8B2500]" data-id="element-142" /> : <ChevronDown size={16} className="text-[#888]" data-id="element-143" />}
            </button>
            <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-[300px] opacity-100 pb-4' : 'max-h-0 opacity-0'}`} data-id="element-144">
              <p className="text-[16px] text-[#4a4a4a] leading-relaxed font-serif" data-id="element-145">
                {faq.a}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}